// Styles constants pour le CategorySelector
export const CATEGORY_SELECTOR_STYLES = {
  trigger:
    'flex items-center justify-between w-full h-10 text-sm bg-transparent border-none pr-2 appearance-none focus:outline-none ring-offset-background placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
  content: 'w-full max-h-96 p-0',
} as const;
